module.exports = __webpack_public_path__ + "static/media/icon-dropdown.45611a2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-dropdown.svg
// module id = 1238
// module chunks = 19